import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-35deafcf"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "input-label-content" };
const _hoisted_2 = {
    key: 0,
    class: /*#__PURE__*/ _normalizeClass(['input-label'])
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ProsemirrorViewerFormInput = _resolveComponent("ProsemirrorViewerFormInput");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.input.inputSettings.type === _ctx.FieldInputType.Checkbox)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2))
            : (_openBlock(), _createBlock(_component_ProsemirrorViewerFormInput, {
                key: 1,
                class: _normalizeClass(['input-label', { 'is-required': _ctx.input.inputSettings.required && _ctx.editable }]),
                "data-external": "form-input-text-label-view",
                content: _ctx.getSafeText(_ctx.input.inputSettings.richTextLabel),
                "merge-values": _ctx.mergeValues,
                fields: _ctx.fields,
                "multi-line": false,
                label: false,
                link: false,
                placeholder: ""
            }, null, 8, ["class", "content", "merge-values", "fields"]))
    ]));
}
